import React, { useEffect, useState } from "react";
import Header from "../components/Header/Header";
import MobileNavbar from "../components/Header/Mobile/MobileNavbar";
import MobileHeader from "../components/Header/Mobile/MobileHeader";
import ScrollTop from "../components/shared/ScrollTop";
import { getData } from "../services/API";
import Footer from "../components/Footer/Footer";
import Loading from "../components/shared/Loading";

const Live = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");

  useEffect(() => {
    getData("/settings/script")
      .then((res) => {
        setContent(res?.data?.content || "");
        setLoading(false);
      })
      .catch(() => {
        setContent({ error: "خطا هنگام نمایش پخش زنده !" });
        setLoading(false);
      });
  }, []);

  // اجرای اسکریپت بعد از اینکه content گرفتیم
  useEffect(() => {
    if (!content || content.error) return;

    // ساخت یک DOM موقت برای استخراج script
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = content;

    const scriptTag = tempDiv.querySelector("script");
    const htmlWithoutScript = tempDiv.innerHTML.replace(scriptTag?.outerHTML, "");

    // قرار دادن HTML (بدون script) در کانتینر
    const container = document.getElementById("live-container");
    if (container) container.innerHTML = htmlWithoutScript;

    // اگر اسکریپت وجود داشت آن را واقعی append کنیم
    if (scriptTag) {
      const newScript = document.createElement("script");
      if (scriptTag.src) newScript.src = scriptTag.src;
      if (scriptTag.id) newScript.id = scriptTag.id;
      newScript.async = scriptTag.async || true;

      container.appendChild(newScript);
    }

    // پاکسازی هنگام خروج از صفحه
    return () => {
      if (container) container.innerHTML = "";
    };
  }, [content]);

  return (
    <div className="flex flex-col items-center justify-center mx-auto">
      <Header />
      <MobileNavbar />
      <MobileHeader />
      <ScrollTop />

      <div className="flex flex-col items-center gap-8 mt-6 mb-20">
        <div className="w-fit flex gap-2 text-2xl mt-3 md:text-[40px] font-black items-center pr-[50px] relative">
          <span className="text-gray-200">پخش</span>{" "}
          <span className="text-yellow-700">زنده</span>
          <div className="dottedSquare"></div>
        </div>

        {loading ? (
          <Loading />
        ) : content?.error ? (
          <p className="text-red-600">{content?.error}</p>
        ) : (
          <div
            id="live-container"
            className="w-full flex justify-center items-center"
            style={{ minHeight: "300px" }}
          ></div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default Live;
